<template>
  <div>
    <div class="white-text-container background-image-container phs-hero">
      <div class="opacity"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-6 lns-hero">
            <h1>Welcome to the Late Night Scholarships Site</h1>
            <p>
              Late Night Scholarships was formed to provide Perry alumni with
              the opportunity to give back to the community and support
              Perry students in their post-secondary education.
            </p>
            <router-link
              :to="{ name: 'donate' }"
              class="btn btn-lg btn-primary lns-action-btn"
              >Donate</router-link
            >
            <router-link
              :to="{ name: 'apply' }"
              class="btn btn-lg btn-danger lns-action-btn lns-apply-btn"
              >Apply</router-link
            >
          </div>
        </div>
      </div>
    </div>

    <div class="section-container border-section-container">
      <div class="container">
        <div class="row">
          <div class="col-md-12 section-container-spacer">
            <div class="text-center">
              <h2>Perry Class of 2025 Winners</h2>
              <p>
                The Late Night Scholarships fund awarded 3 scholarships to
                graduating seniors in the Perry Class of 2025. The winners
                include Danae Lopez, Benjamin Thompson, and Chloe Dostal.
                Congratulations to our winners!
              </p>
            </div>
          </div>
        </div>
        <div class="row winner">
          <div class="col-md-4">
            <div class="winner-photo">
              <img src="@/assets/images/winners/lopez.jpg"/>
            </div>
            <div class="text-center">
              <h3>Danae Lopez</h3>
            </div>
          </div>
          <div class="col-md-8">
            <p>
              Danae Lopez will be majoring in Biochemistry at The Ohio State University.
            </p>
          </div>
        </div>
        <div class="row winner">
          <div class="col-md-4">
            <div class="winner-photo">
              <img src="@/assets/images/winners/thompson.jpg"/>
            </div>
            <div class="text-center">
              <h3>Benjamin Thompson</h3>
            </div>
          </div>
          <div class="col-md-8">
            <p>
              Benjamin Thompson will be attending the University of Akron to major in Mechanical Engineering.
            </p>
          </div>
        </div>
        <div class="row winner">
          <div class="col-md-4">
            <div class="winner-photo">
              <img src="@/assets/images/winners/dostal.jpg"/>
            </div>
            <div class="text-center">
              <h3>Chloe Dostal</h3>
            </div>
          </div>
          <div class="col-md-8">
            <p>
              Chloe Dostal will be attending The Ohio State University to major in Marketing.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      class="section-container background-color-container white-text-container"
    >
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="text-center">
              <h2>Donate to the Scholarship Fund</h2>
              <p>
                The Late Night Scolarships fund is accepting donations for the
                Class of 2026 scholarships. Last year, we collected over $4,500
                from over 35+ donors. 100% of donations go towards the
                scholarships. All donors have the option to review the
                anonymized applications and vote for which applicants should
                receive the scholarships.
              </p>
              <router-link
                :to="{ name: 'donate' }"
                class="btn btn-primary btn-lg"
                >Donate</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-container">
      <div class="container">
        <div class="row">
          <div class="col-md-7">
            <img
              class="img-responsive"
              src="@/assets/images/img-06.png"
              alt="lns logo"
            />
          </div>

          <div class="col-md-5">
            <ul class="features">
              <li>
                <h3>Contribute to a Noble Cause</h3>
                <p>
                  Enable Perry students to attend further their education with reduced financial
                  obstacles.
                </p>
              </li>
              <li>
                <h3>Maintain Transparency into the Scholarship Process</h3>
                <p>
                  Help the fund review scholarship applications and vote for
                  which applicants should receive the awards.
                </p>
              </li>
              <li>
                <h3>Build an Alumni Base</h3>
                <p>
                  Reach out to fellow alumni to raise awareness and show our
                  support for the next generation of Perry professionals.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {},
};
</script>

<style scoped>
.phs-hero {
  background-image: url("~@/assets/images/img-home.jpg");
}
</style>